import { LESSONS_URL_FRAGMENT, TRACKS_URL_FRAGMENT } from '../../constants/Navigation';
import { getPlaylistUrl } from '../../utils/RoutingUtils';
import { getShortContentUrl } from '../shortContent/shortContentRouting';
export const getLearningContentItemPath = ({
  id,
  type
}) => {
  switch (type) {
    case 'TRACK':
      return `${TRACKS_URL_FRAGMENT}/${id}`;
    case 'LESSON':
      return `${LESSONS_URL_FRAGMENT}/${id}`;
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      return getPlaylistUrl(id);
    case 'SHORT_FORM_CONTENT':
      return getShortContentUrl({
        shortId: id
      }).fullUrl;
    default:
      return '';
  }
};
export const getLearningContentItemSearchParams = ({
  type,
  language
}) => {
  const search = new URLSearchParams();
  if (language) search.set('language', language);
  switch (type) {
    case 'TRACK':
    case 'LESSON':
      return search.toString();
    default:
      return null;
  }
};
export const getLearningContentItemRoute = item => ({
  path: getLearningContentItemPath(item),
  search: getLearningContentItemSearchParams(item)
});
export const getLearningContentItemUrl = item => {
  const params = getLearningContentItemSearchParams(item);
  return `${getLearningContentItemPath(item)}${params ? `?${params}` : ''}`;
};